export const const_procesos = {
    dir_user: 'user_chs_plus',
    dir_socket: '/api_socket',
    dir_tasa:'tasa_cambio',
    //Nombre de variable de configuracion
    dir_config: 'config_servchs+',
    
  }